<template>
  <h2 class="section__title section__title--error">{{ $t('main-page.rejected.back-to-pharmacy.confirmed-back-to-pharmacy') }}</h2>
</template>

<script>
export default {
  name: 'confirmed-back-to-pharmacy',
}
</script>
